import { Box, Heading, Stack, SimpleGrid, Image } from "@chakra-ui/react";
import { Button } from "components";
import { InternalLink } from "components/atoms/InternalLink";
import { IProduct } from "interfaces/product.interface";
import { EXTERNAL_LINKS, route } from "config/routes";
import { ProductCustomCheckpoints } from "./ProductCustomCheckpoints";

export const ProductPageCTA = ({
  product,
  customImage,
  customGetStarted,
  hasBookDemo,
}: {
  product: IProduct;
  customImage?: string;
  customGetStarted?: string;
  hasBookDemo?: boolean;
}) => {
  const { color, ctaCheckpoints } = product;

  return (
    <Box bg={{ lg: "gray.100" }} rounded="md" overflow="hidden">
      <Box display={{ lg: "flex" }} alignItems="center">
        <Box flex={1} p={{ lg: 12 }}>
          <Heading mb={5}>Ready to get started?</Heading>
          {ctaCheckpoints && (
            <ProductCustomCheckpoints items={ctaCheckpoints} color={color} />
          )}
          <SimpleGrid columns={2} spacing={4}>
            <Box>
              <Box
                as="a"
                href={customGetStarted || EXTERNAL_LINKS.SIGNUP_UP.href}
              >
                <Button size="lg" isWide color={color} isBlock>
                  Get Started
                </Button>
              </Box>
            </Box>
            {hasBookDemo && (
              <Box>
                <InternalLink href={route("DEMO_INDEX")}>
                  <Button size="lg" isWide color="default" isBlock>
                    Book a demo
                  </Button>
                </InternalLink>
              </Box>
            )}
          </SimpleGrid>
        </Box>
        <Box flex={1} display={{ base: "none", lg: "block" }}>
          <Box
            shadow="sm"
            border="1px solid"
            right={0}
            bottom={-12}
            position="relative"
            rounded="md"
            overflow="hidden"
            borderColor="gray.150"
          >
            <Image
              src={customImage || "/images/screenshots/case-study-1.png"}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
